import React from 'react'
import { Link } from 'react-router-dom'
import makeStyles from '@material-ui/styles/makeStyles'
import { LANDING } from '../../constants/routes.js'
// import { ReactComponent as FlokaBetaLogo } from '../../assets/floka-logo-login-beta.svg'
import { ReactComponent as FlokaLogo } from '../../assets/FLÖKA.svg'
import practitionerFlokaLogo from '../../assets/floka-icon-beta1.png';
import practitionerLogo from '../../assets/Practitioner.png'


/**
 * Floka logo on the SideBar
 * Redirect to HOME page on click
 * @return  {component}  A Floka LogoButton that redirect to 'HOME' page on click
 */

function LogoButton(props) {
    const useMainStyles = makeStyles(() => ({
        root: {
            width: '70%',
            paddingLeft: '10%',
            paddingTop: '24px',
        },
    }))

    const useBetaStyles = makeStyles(() => ({
        root: {
            width: '70%',
            paddingLeft: '25%',
        },
        img:{
            width:'180px'
        }
    }))

    const classesMain = useMainStyles()
    const classesBeta = useBetaStyles()

    return (
        <Link to={LANDING}>
            {props.useMain ? (
                <FlokaLogo className={classesMain.root} />
            ) : (
                <img className={classesBeta.img} src={practitionerLogo} alt='floka logo'/>
                // <FlokaBetaLogo className={classesBeta.root} />
            )}
        </Link>
    )
}

export default LogoButton
